import {BaseFilterRequest} from '../base-filter-request';
import {Stringifier} from '../../../services/stringifier.service';

@Stringifier
export class FilterMoviesRequest extends BaseFilterRequest {
  pay1?: boolean;
  pay2?: boolean;
  pay3?: boolean;
  svod?: boolean;
  freeTv?: boolean;
  libraryFreeTv?: boolean;
  librarySvod?: boolean;

  reserved?: boolean;
  available?: boolean;

  timeFrom?: Date;
  timeTo?: Date;

  searchText?: string;

  static getStringifier(level: number): FilterMoviesRequest | null {
    if (level < 0) {
      return null;
    }
    // @ts-ignore
    return {
      pay1: null,
      pay2: null,
      pay3: null,
      svod: null,
      freeTv: null,
      reserved: null,
      available: null,
      libraryFreeTv: null,
      librarySvod: null,
      timeFrom: null,
      timeTo: null,
      searchText: null,
    } as FilterMoviesRequest;
  }
}
